import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {LoaderService} from '../../../general-services/service-loader/loader.service';
import {NumAnnoMeseService} from '../../../general-services/service-num-anno-mese/num-anno-mese.service';
import * as toastr from 'toastr';
import {MinimumCommModel} from '../../../../models/MinimumCommModel';
import {MinimumCommService} from '../service-minimum-comm/minimum-comm.service';
import {ProviderModel} from '../../../../models/ProviderModel';
import {BaseGeneralComponent} from '../../../BaseGeneralComponent';

@Component({
  selector: 'app-new-minimum-comm',
  templateUrl: './new-minimum-comm.component.html',
  styleUrls: ['./new-minimum-comm.component.scss']
})
export class NewMinimumCommComponent extends BaseGeneralComponent implements OnInit, OnDestroy {

  showActions: boolean;
  anagrafInSettings: boolean;
  showProvider: boolean;

  providerSelect: ProviderModel;

  minimumComm: MinimumCommModel;
  saveMinimumComm: Subscription;

  registerForm: FormGroup;
  submitted = false;

  allYear: any;
  getPageSubscribe: Subscription;

  constructor(private route: ActivatedRoute, private router: Router,
              private minimumCommService: MinimumCommService,
              private formBuilder: FormBuilder,
              private loaderService: LoaderService,
              private annoMeseService: NumAnnoMeseService) {
    super();

    this.showActions = false;
    this.anagrafInSettings = true;
    this.minimumComm = new MinimumCommModel();
    this.providerSelect = new ProviderModel();
  }

  ngOnInit() {
    this.registerForm = this.formBuilder.group({
      provider: [{value: '', disabled: false}, Validators.required],
      year: [{value: '', disabled: false}, Validators.required],
      value: [{value: '', disabled: false}, Validators.required]
    });

    this.getAllYear();
  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.CONTRACTUAL_DATA], {queryParams: {selectedIndex: 2}});
  }

  save() {
    this.submitted = true;
    if (this.registerForm.valid) {
      this.minimumComm.anno = this.registerForm.value.year;
      this.minimumComm.value = this.registerForm.value.value;
      event.preventDefault();
      this.loaderService.display(true);
      this.saveMinimumComm = this.minimumCommService.save(this.minimumCommService.baseUrl, this.minimumComm)
        .subscribe(
          (result: any) => {
            if (result === -1) {
              toastr.options.timeout = 5000;
              toastr.warning('Duplicate item, cannot be created', 'Warning');
              this.loaderService.display(false);
            } else {
              toastr.success('Minimum Commitment was created with success', 'Success');
              this.loaderService.display(false);
              this.router.navigate([this.LINKS.CONTRACTUAL_DATA], {queryParams: {selectedIndex: 2}});
            }
          },
          error => {
            toastr.error('Minimum Commitment was not created', 'Error');
            this.loaderService.display(false);
          });
    }
  }

  ngOnDestroy(): void {
    if (this.saveMinimumComm) {
      this.saveMinimumComm.unsubscribe();
    }
  }

  handleYear(value) {
    this.minimumComm.anno = value;
    this.registerForm.patchValue({
      anno: value
    });
  }

  getElementSelectedProvider($event) {
    this.minimumComm.provider = $event.row;
    this.providerSelect = $event.row;
    this.registerForm.patchValue({
      provider: this.providerSelect.cod
    });
  }

  toggleProvider() {
    this.showProvider = !this.showProvider;
  }

  // convenience getter for easy access to form fields
  get f() { return this.registerForm.controls; }

  getAllYear() {
    this.getPageSubscribe = this.annoMeseService.getAllYear()
      .subscribe(
        (result: any) => {
          this.allYear = result;
        });
  }

  resetAll() {
    this.showProvider = false;
    this.resetProvider();
  }

  resetProvider() {
    this.registerForm.patchValue({
      provider: ''
    });
    this.providerSelect = new ProviderModel();
  }

}
